// This is our source of truth for translation keys
const en = {
  translation: {
  select_a_community: 'Select a Community',
  no: 'No',
  yes: 'Yes',
  flu_symptoms_question: 'Are you or anyone else touring the home experiencing flu-like symptoms?',
  tour_not_found: 'Tour not found',
  cancel_tour: 'Cancel Tour',
  confirm_cancel_tour: 'Would you like to cancel the tour?',
  "policy_decline": "I have read and decline the {{builder}}'s communication policy.",
  "network_or_error": "Something went wrong Or Network err !!!",
  "generic_error": "Something went wrong",
  "create_account_error": "We could not create your account. Please try again.",
  "register": "Register",
  "temporary_password_sent": "A temporary password was sent to your email. It is valid for the next 15 minutes.",
  "enter_email": "Please Enter your email address.",
  "passwordless_login": "Passwordless login",
  "temporary_password_action": "Send temporary password.",
  "forgot_password": "Forgot your password?",
  "password": "Password",
  "email": "Email",
  "hello": "Hello,",
  "login_below": "Please Login Below",
  "nice_to_see": "Nice to See You Again!",
  "make_permanent": "Let’s make this permanent:",
  "nice_to_meet": "Nice to Meet You!",
  "next": "Next",
  "resend": "Resend.",
  "retry_in": "Try again in {{seconds}}s.",
  "having_trouble": "Having trouble?",
  "enter_otp": "Enter the code sent to your phone.",
  "generic_retry": "Something went wrong. Please try again.",
  "otp_invalid": "Invalid code. Please try again.",
  "otp_not_verified": "OTP is not verified, try again or resend it.",
  "otp_resend_error": "Could not resend code. Please try again.",
  "otp_sent": "A new code was sent to your phone.",
  "retry_seconds": "Too many attempts. Try again in {{seconds}}s.",
  "send_code_error": "Could not send the code. Please try again.",
  "phone_expired": "Your phone verification expired. Please verify your phone number again.",
  "login": "Login",
  "enter_phone": "Please enter your phone number",
  "phone_verification": "Phone Verification",
  "network_error": "Please check your connection, Network Error !!!",
  "model": "MODEL",
  "square_feet_short": "Sqft",
  "half_baths_short": "Hba",
  "full_baths_short": "Fba",
  "beds_short": "Bd",
  "per_month": "/month",
  "property_id": "Property ID",
  "lot": "Lot",
  "no_search_results": "No Result Found !!!",
  "property_search_placeholder": "Search by Property ID, Address, or Lot Num",
  "no_community_homes": "Currently, there are no homes available for tours",
  "community_placeholder": "Please select a community",
  "community_question": "What community would you like to tour?",
  "schedule_self_tour": "Schedule in person self tour!",
  "in_person_tour": "In Person Tour",
  "tour_preference_question": "How do you want to tour?",
  "required": "required",
  // Common
  "welcome": "Welcome to our app",
  "language": "Language",
  "continue": "Continue",
  "or": "OR",
  "need_help": "Need Help?",
  "powered_by": "Powered By",
  "copyright": "Copyright",
  "header_logo": "Builder Logo",
  "try_again": "Try Again",
  "uh_oh": "Uh-Oh",
  "community": "Community",
  "accept": "Accept",

  // Languages
  "english": "English",
  "spanish": "Spanish",

  // Authentication
  "sign_in_with_phone": "Sign in with your phone number.",
  "need_account": "Need an account with NterNow?",
  "register_here": "Register here",
  "phone_placeholder": "000-000-0000",

  // Navigation
  "back": "Back",

  // Errors
  "phone_required": "Your phone number is required. Please re-enter it or sign up for an account.",
  "property_not_found_title": "Property not found",
  "property_unavailable_title": "Property unavailable",
  "tour_unavailable_title": "Tour unavailable",
  "session_expired_title": "Session expired",
  "tour_restart_needed_title": "Let's restart your tour",
  "temporary_problem_title": "Temporary problem",
  "refresh_needed_title": "Refresh needed",
  "something_went_wrong_title": "Something went wrong",
  "property_not_found_message": "This property couldn't be found or is no longer available.",
  "property_unavailable_message": "This property is not currently available for self-touring.",
  "tour_unavailable_message": "This tour cannot be started right now.",
  "identity_verification_required_message": "Identity verification is required before this tour can start.",
  "tour_location_not_confirmed_message": "We couldn't confirm your location for this tour. Please check location permissions or contact support.",
  "adc_backup_code_unavailable_message": "We couldn't get an access code for this property. Please try again or contact support.",
  "session_expired_message": "Your session has expired. Please try again.",
  "tour_restart_needed_message": "We couldn't continue the previous tour. Please choose another property or contact support.",
  "temporary_problem_message": "We couldn't load this property because of a temporary connection problem.",
  "refresh_needed_message": "We couldn't refresh the property information. Please try again.",
  "something_went_wrong_message": "Something went wrong while loading this property. Please try again.",
  "property_id_invalid_message": "The property identifier is invalid. Please check it and try again.",
  "access_problem_retry_help": "Try again if the problem is temporary, or choose another property.",
  "access_problem_terminal_help": "Please choose another property or contact support for help.",
  "no_active_lock": "We're sorry there is an issue getting access. There is no active lock on the property. Please call live support or try another property that is enabled for tours.",
  "access_issue": "We're sorry there is an issue getting access. {propStatusDescription}. Please call live support or try another property that is enabled for tours.",
  "accept_terms_error": "You must accept our terms and conditions to continue",

  // COVID Notice
  "covid_notice": "I understand that during the COVID-19 crisis, I am touring at my own risk and will ensure to follow the 5 CDC recommended guidelines when conducting a self-tour. For more information:",
  "covid_policy": "COVID-19 policy",

  // Property viewing
  "select_tour_date": "Select Tour Date",
  "previous_tours": "Previous Tours",
  "upcoming_tours": "Upcoming Tours",
  "choose_community": "Choose Community",
  "search_community": "Search Community",
  "book_a_tour": "Book a Tour",
  "tours": "Tours",
  "enter_property_id": "Enter Property ID",
  "property_id_placeholder": "Enter the 5 digit property ID on the door",
  "property_label": "Property",
  "explore_other_properties": "Explore other available properties",
  "find_other_properties": "Find other properties",

  // Account
  "edit_profile": "Edit Profile",
  "my_profile": "My Profile",
  "sign_in": "Sign In",
  "sign_out": "Sign Out",

  // Disclosure
  "disclosure_consent": "By selecting this box, I agree that I am 18 years or older and agree to be contacted by NterNow or the property owner or manager according to the",
  "visitor_access_agreement": "Visitor Access Agreement",
  "disclosure_intro": "I have read and accept NterNow’s",
  "biometric_policy": "Biometric Policy",
  "disclosure_and": "and",
  "visitor_access_agreement_body": "Customer agrees that any entry onto the property is at the Customer’s own risk. Customer hereby waives any and all claims against {{companyName}} Inc., its affiliates, subsidiaries, owners, officers, directors, managers, employees, representatives or agents (collectively, “{{companyName}}”) for injury or damage to person or property arising from, or related to, Customer’s entry onto the property. Customer will defend, indemnify and hold {{companyName}} harmless against any injury, loss, damage or expense to person or property arising from, or related to, the acts or omissions of Customer, or of any person accompanying Customer onto the property. Customer will act in accordance with all applicable laws while on the property. Customer will not provide any false information or identification. Customer will be responsible for all damage to furniture, fixtures and equipment caused, directly or indirectly, by Customer. If you experience any difficulty viewing, accessing, or navigating NterNow, please contact us at {{supportEmail}}.",

  // Other pages
  "how_it_works": "How it Works",
  "feedback": "Feedback",
  "offer": "Offer",
  "help": "Help",
  "support": "Support",
  "privacy_policy": "Privacy Policy",
  "terms_legal": "Terms",
  "terms_of_service": "Terms of Service",
  "housing_opportunities": "Housing Opportunities",

  // Booking.
  "booking_required": "Required",
  "booking_future_time": "Time must be greater than current time",
  "booking_property_sold": "Property is Sold",
  "booking_required_label": "required",
  "booking_lot": "Lot",
  "booking_property_id": "Property ID",
  "booking_per_month": "/month",
  "booking_bedrooms_short": "Bd",
  "booking_full_baths_short": "Fba",
  "booking_half_baths_short": "Hba",
  "booking_sqft_short": "Sqft",
  "booking_register_to_tour": "Register to Tour",
  "booking_in_community": "in",
  "booking_choose_day": "What day would you like to tour?",
  "booking_choose_time": "What time would you like to tour?",
  "booking_today_upper": "TODAY",
  "booking_now": "NOW",
  "booking_no_slots_today": "There are no more tour slots available today. Please select another day.",
  "booking_tour_now": "Tour Now",
  "booking_schedule": "Schedule",

  // Homepage
  "ready_tour": "Ready to tour?",
  "start_touring_button": "Start Touring Now"
  }
};

// Create types based on the English translations structure, but allow any string values
export type TranslationKeys = {
  [K in keyof typeof en.translation]: string;
};

export type TranslationResource = {
  translation: TranslationKeys;
};

export default en;
